import { render } from "./PendingReviewTable.vue?vue&type=template&id=286df848&scoped=true"
import script from "./PendingReviewTable.vue?vue&type=script&lang=js"
export * from "./PendingReviewTable.vue?vue&type=script&lang=js"

import "./PendingReviewTable.vue?vue&type=style&index=0&id=286df848&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286df848"]])

export default __exports__